import { Component, OnInit } from '@angular/core';
import { EstudoRenovacaoService } from './estudo-renovacao.service';
import { MatSnackBar } from '@angular/material';
import { EstudoRenovacao } from './estudo-renovacao';
import { Router } from '@angular/router';
import { ConfirmacaoDialog } from "../util/confirmacao.dialog";

@Component({
  selector: 'estudo-renovacao-app',
  templateUrl: './estudo-renovacao.component.html',
  styleUrls: ['estudo-renovacao.component.css']
})
export class EstudoRenovacaoComponent implements OnInit {
  public isLoading: boolean;
  public estudoRenovacao: EstudoRenovacao = new EstudoRenovacao();
  public mensagemTela: String;
  public botaoSalvar: boolean;
  public carSelected: boolean

  constructor(
    private estudoRenovacaoService: EstudoRenovacaoService,
    private mensagem: MatSnackBar,
    private router: Router) {
    
  }

  public ngOnInit() {
    this.inicializa();
  }

  private inicializa() {
    let storage = JSON.parse(localStorage.getItem("sae"));
    let user = null;

    const matricula = storage["user"];
    this.isLoading = true;
    this.estudoRenovacaoService.inicializa(matricula).subscribe(
      (result: EstudoRenovacao) => {
        if (result && result.aluno) {
          this.estudoRenovacao = result;
          this.controleRespostaRenovacao();
          this.isLoading = false;
        } else {
          //se chegar null entao ele nao pode renovar. Aí redireciono pro estudo normal
          this.router.navigate(['/estudo']);
        }
      },
      error => this.erro(error)
    );
  }

  erro(erro: string) {
    this.mensagem.open(erro, 'X');
  }


  salvar(): void {    
    this.estudoRenovacaoService.update(this.estudoRenovacao).subscribe(
      result => {
        this.estudoRenovacao = result;
        this.controleRespostaRenovacao();
      },
      error => this.erro(error)
    );
  }

  // de acordo com a resposta do questionario renovacao eu devo prosseguir ou manter na mesma tela 
  controleRespostaRenovacao(){
    if(this.estudoRenovacao.houveAlteracaoSituacao == true){
      this.router.navigate(['/estudo']);
      this.botaoSalvar= false;
    }else if(this.estudoRenovacao.houveAlteracaoSituacao == false){
      // se jah foi renovado então pode ir pro estudo
      if(this.estudoRenovacao.renovado){
        this.router.navigate(['/estudo']);
        this.botaoSalvar= false;
      }
      this.mensagemTela = "Sua inscrição foi salva com sucesso. Você já está concorrendo aos programas de assistência estudantil nesse semestre.  ";
      this.botaoSalvar= false;
    }else{
      this.botaoSalvar= true;
    }    
  }
  


}



